import {
  AccountingConnection,
  AccountingConnectionList,
  AccountingConnectionPartner
} from "@wingspanhq/wingspan-api-sdk";

/**
 * The account's QuickBooks accounting connection — the v3 replacement for the
 * dedicated v1 `GET /integrations/quickbooks/service`. v3 has no single-connection
 * endpoint; the connection is derived from `listAccountingConnections` filtered to
 * the QuickBooks partner. `undefined` means QBO was never connected.
 */
export const selectorQuickbooksConnection = (
  connections?: AccountingConnectionList
): AccountingConnection | undefined =>
  connections?.data?.find(
    connection => connection.partner === AccountingConnectionPartner.QUICKBOOKS
  );
